<script lang="ts" setup>
import { useI18n } from "vue-i18n";
import { GenderEnum } from "@/enums/mateEnums";
import { useStaticUrl } from "@/use/common";

const props = defineProps<{
  gender: GenderEnum | null;
}>();
const emit = defineEmits<{
  (e: "update:gender", value: GenderEnum.MALE | GenderEnum.FEMALE): void;
}>();
const { t } = useI18n();
const genderConfig: {
  text: string;
  url: string;
  value: GenderEnum.MALE | GenderEnum.FEMALE;
}[] = [
  {
    text: t("loginmodal.male"),
    url: useStaticUrl("/login/male.png"),
    value: GenderEnum.MALE,
  },
  {
    text: t("loginmodal.female"),
    url: useStaticUrl("/login/female.png"),
    value: GenderEnum.FEMALE,
  },
];
</script>
<template>
  <div class="flex flex-col gap-10 items-center justify-center">
    <div class="text-white text-[2rem] font-bold text-center">
      {{ $t("loginmodal.createYourCharacter") }}
    </div>
    <div class="flex gap-2">
      <div
        v-for="(item, idx) in genderConfig"
        :key="idx"
        :class="{ grayscale: gender !== item.value }"
        class="flex flex-col gap-2 cursor-pointer relative"
        @click="emit('update:gender', item.value)"
      >
        <!--            <div-->
        <!--              :class="{ grayscale: genderSelection !== item.value }"-->
        <!--              class="absolute left-0 right-0 top-0 bottom-0"-->
        <!--            ></div>-->
        <div
          class="rounded overflow-hidden shadow-lg pointer-events-none w-40 aspect-[3/4]"
        >
          <base-img
            :url="item.url"
            :width="160"
            fit="object-contain"
            ratio="3:4"
          />
        </div>
        <div class="flex justify-center items-center text-base gap-1">
          <span
            :class="{
              'text-base-content/50': gender !== item.value,
              'text-primary': gender === item.value,
            }"
          >
            {{ item.text }}
          </span>
          <input
            :checked="gender === item.value"
            :class="gender === item.value ? 'radio-primary' : 'radio-secondary'"
            class="radio radio-xs"
            type="radio"
          />
        </div>
      </div>
    </div>
  </div>
</template>
